import { SxProps, Theme } from "@mui/material";

export const tableTextStyles: SxProps<Theme> = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "14px",
  fontWeight: 400,
};

export function getInitials(name: string): string {
  if (!name) return "?";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

const avatarColors = [
  "#7C3AED", // purple
  "#059669", // green
  "#DC2626", // red
  "#2563EB", // blue
  "#D97706", // amber
  "#0891B2", // cyan
  "#7C3AED", // violet
  "#DB2777", // pink
];

export function getAvatarColor(name: string): string {
  const index =
    name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) %
    avatarColors.length;
  return avatarColors[index];
}
